import {GridIdNameModel} from '../../types';
import React, {useEffect, useRef, useState} from 'react';
import {GridDropdown, GridDropdownOption} from '../dropdown';
import Box from '@mui/material/Box';
import Skeleton from '../../../skeleton';

import styles from './edit-cell.module.scss';

interface Props {
    value: number,
    options: GridIdNameModel[],
    getOptions?: () => Promise<GridIdNameModel[]>,
    active: boolean,
    onChange: (value: any) => void,
    lazyLoad?: boolean,
    placeholder?: any,
}

const DropdownEditCell = (props: Props) => {
    const {
        options,
        getOptions,
        active,
        onChange,
        lazyLoad,
        placeholder
    } = props;
    const ref = useRef<HTMLButtonElement>(null);
    const [value, setValue] = React.useState<number | null>(props.value);
    const [internalOptions, setInternalOptions] = useState<GridIdNameModel[] | undefined>(() => {
        if (getOptions && lazyLoad && lazyLoad) {
            return undefined
        }

        return options
    })
    const commit = (val: number | null = value) => {
        onChange(val);
    };

    const close = () => {
        ref.current?.blur();
    };

    const handleSelect = (val: number | null) => {
        setValue(val);
        commit(val);
        close();
    };

    useEffect(() => {
        setValue(props.value ?? null);
    }, [props.value]);
    useEffect(() => {
        if (active) {
            if (getOptions) {
                getOptions().then((r) => {
                    setInternalOptions(r);
                });
            } else {
                setInternalOptions(options);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [active, getOptions, options]);

    const shouldRenderPlaceholderOption = placeholder && value !== null
        && !internalOptions?.some((option) => option.id === value);

    return <GridDropdown ref={ref}
        multiple={false}
        value={value ?? null}
        autoFocus={true}
        aria-expanded={active}
        aria-haspopup={true}
        listboxOpen={active}
        onChange={(_, value) => handleSelect(value)}>
        {
            internalOptions !== undefined ? <>
                {shouldRenderPlaceholderOption && (
                    <GridDropdownOption key={value} value={value}>{placeholder}</GridDropdownOption>
                )}
                {internalOptions.length > 0
                    ? internalOptions.map((o) => (
                        <GridDropdownOption key={o.id} value={o.id}>{o.name}</GridDropdownOption>))
                    : <Box
                        display={'flex'}
                        width={'100%'}
                        justifyContent={'flex-start'}
                        flexDirection={'column'}
                        padding={'8px 14px'}>
                                No Data
                    </Box>}
            </>
                : <>
                    {placeholder && <GridDropdownOption key={value} value={value}>{placeholder}</GridDropdownOption>}
                    <Box display={'flex'} width={'100%'} justifyContent={'flex-start'} flexDirection={'column'}>
                        {
                            [1, 2].map((_x, index) => (
                                <div key={index} className={styles.skeletonWrapper}><Skeleton animation={'wave'}/>
                                </div>))
                        }
                    </Box>
                </>
        }
    </GridDropdown>
}

export default DropdownEditCell;
